export default [

  {
    path: '/tracking/live',
    name: 'tracking.live',
    component: () => import('@/views/modules/maps/Live.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/tracking/route/:id/:from/:to/:contract_id',
    name: 'tracking.route',
    component: () => import('@/views/modules/maps/Route.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/trackingLive/route/:id/:from/:to/:contract_id',
    name: 'tracking.routeLive',
    component: () => import('@/views/modules/maps/RouteLive.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/tracking/history',
    name: 'tracking.history',
    component: () => import('@/views/maps/history/HistoryMap'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/map/containers',
    name: 'get.map.containers',
    component: () => import('@/views/maps/ContainersMap.vue'),
    meta: {
      layout: 'full',
    },
  },


  {
    path: '/tracking/getDevicePlan/:id/:from/:to',
    name: 'tracking.getDevicePlan',
    component: () => import('@/new/pages/map/ContainersMapWindow.vue'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/device/:id/getRoute/from/:from/to/:to',
    name: 'tracking.rfidRoute',
    component: () => import('@/views/reports/RFIDContainerDump/CompactorRoute.vue'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/device/:id/live',
    name: 'maps.deviceLivePopup',
    component: () => import('@/views/maps/DeviceLivePath.vue'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/device/:id/history',
    name: 'maps.deviceHistoryPopup',
    component: () => import('@/views/maps/DeviceHistoryPath.vue'),
    meta: {
      layout: 'full',
    },
  },



  {
    path: '/containers-paths',
    name: 'get.containers.paths',
    component: () => import('@/views/maps/ContainersPaths/ContainersPaths.vue'),
    meta: {
      layout: 'full',
    },
  },

]
